import React, { memo, useEffect, useState } from 'react';
import { bool, arrayOf } from 'prop-types';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { isEmpty } from '@widergy/web-utils/lib/array';

import { appConfig } from 'config/customization';
import { ROUTES } from 'constants/routes';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { clientNumberField } from 'constants/fields';
import { accountUnpaidType } from 'types/paymentTypes';

import PaymentByNis from './layout';

const PaymentByNisContainer = ({ dispatch, loading, accountUnpaid }) => {
  const [submited, setSubmited] = useState(false);

  const onSubmit = values => {
    setSubmited(true);
    dispatch(paymentActions.getAccountUnpaid({ client_number: values.clientNumber }));
  };

  const handleBackToHome = () => {
    const route = appConfig.publicDashboard.home ? ROUTES.PUBLIC_HOME : ROUTES.PUBLIC_PAYMENTS;
    dispatch(push(route));
  };

  useEffect(() => {
    if (submited && !loading && !isEmpty(accountUnpaid)) {
      dispatch(push(ROUTES.PUBLIC_PAYMENT_DOCUMENTS));
    }
  }, [loading, accountUnpaid]);

  return (
    <PaymentByNis
      onSubmit={onSubmit}
      onGoToHome={handleBackToHome}
      fields={[clientNumberField]}
      loading={loading}
    />
  );
};

PaymentByNisContainer.propTypes = {
  loading: bool,
  accountUnpaid: arrayOf(accountUnpaidType)
};

const mapStateToProps = store => ({
  loading: store.payment.accountUnpaidLoading,
  accountUnpaid: store.payment.accountUnpaid
});

export default connect(mapStateToProps)(memo(PaymentByNisContainer));
